import Vue from "vue";
const rules = {
  methods: {
    goToByRules(obj) {
      if (!obj.value) return;
      if (obj.rulesInfo.rulesType == 2) {
        //日期 文件 图片都是无条件跳转
        for (let item of obj.rulesInfo.rules) {
          this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
          break;
        }
      } else if (obj.rulesInfo.rulesType == 1) {
        for (let item of obj.rulesInfo.rules) {
          //rulesJump 1正常结束 2提前结束 3跳转到相应题目
          // displayType：1单行 2多行 3单选 4下拉单选 5多选 6下拉多选  type 9 单选图片 10 多选图片 图片没有下拉格式
          if (
            obj.displayType == 1 ||
            obj.displayType == 2 ||
            obj.displayType == 3 ||
            obj.displayType == 4 ||
            obj.displayType == 5 ||
            obj.displayType == 6 ||
            obj.type == 9 ||
            obj.type == 10
          ) {
            //1等于/选中 2包含/未选中
            if (
              obj.displayType == 5 ||
              obj.displayType == 6 ||
              obj.type == 10
            ) {
              obj.value = obj.value.split(",").sort().join(",");
              item.rulesSelect = item.rulesSelect.split(",").sort().join(",");
            }
            if (item.rulesCondition == 1) {
              if (obj.value == item.rulesSelect) {
                this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                break;
              }
            } else if (item.rulesCondition == 2) {
              if (obj.displayType == 1 || obj.displayType == 2) {
                if (obj.value.indexOf(item.rulesSelect) > -1) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
              } else {
                if (
                  (obj.displayType == 3 ||
                    obj.displayType == 4 ||
                    obj.type == 9) &&
                  obj.value != item.rulesSelect
                ) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
                if (
                  (obj.displayType == 5 ||
                    obj.displayType == 6 ||
                    obj.type == 10) &&
                  obj.value.indexOf(item.rulesSelect) == -1
                ) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
              }
            }
          }
        }
      }
    },
    goTo(rulesJump, sortBy, rulesGoto) {
      //rulesJump 1正常结束 2提前结束 3跳转到相应题目
      if (rulesJump == 2) {
        this.goToEnd(sortBy);
      } else if (rulesJump == 3) {
        this.goToSelectCode(sortBy, rulesGoto);
      }
    },
    recoveryData(sortBy) {
      this.resultList.forEach((item, index) => {
        if (item.sortBy > sortBy) {
          item.isShow = item.isOldShow;
          Vue.set(this.resultList, index, item);
        }
      });
    },
    goToEnd(sortBy) {
      this.resultList.forEach((item, index) => {
        if (item.sortBy > sortBy) {
          item.isShow = false;
          Vue.set(this.resultList, index, item);
        }
      });
    },
    goToSelectCode(sortBy, rulesGoto) {
      let goItem = this.resultList.find((a) => a.fieldName == rulesGoto);
      if (goItem) {
        this.resultList.forEach((item, index) => {
          if (item.sortBy > sortBy && item.sortBy < goItem.sortBy) {
            item.isShow = false;
            Vue.set(this.resultList, index, item);
          }
          if (item.sortBy == goItem.sortBy) {
            item.isShow = true;
            Vue.set(this.resultList, index, item);
          }
        });
      }
    },
  },
};
export default rules;
